/* [ START OF MODULE - VER 0.6.11 (src/TigerGate.jsx) ] */
import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import logo from './assets/Logo.png';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
  *{box-sizing:border-box;margin:0;padding:0}
  :root{
    --ttl-blue:#5899CD;--ttl-purple:#824AF8;--ttl-coral:#F37664;--ttl-dark:#231F20;
    --ttl-grad:linear-gradient(135deg,#5899CD 0%,#824AF8 55%,#F37664 100%);
  }
  .gate-root{min-height:100vh;background:var(--ttl-dark);display:flex;align-items:center;justify-content:center;font-family:'Poppins',sans-serif;overflow:hidden;position:relative}
  .gate-bg{position:fixed;inset:0;z-index:0}
  .gate-blob{position:absolute;border-radius:50%;filter:blur(90px)}
  .gate-blob--1{width:520px;height:520px;background:var(--ttl-purple);opacity:.17;top:-130px;left:-130px;animation:gDrift 12s ease-in-out infinite alternate}
  .gate-blob--2{width:430px;height:430px;background:var(--ttl-blue);opacity:.15;bottom:-90px;right:-90px;animation:gDrift 16s ease-in-out infinite alternate-reverse}
  .gate-blob--3{width:290px;height:290px;background:var(--ttl-coral);opacity:.09;top:50%;left:50%;animation:gDrift2 10s ease-in-out infinite alternate}
  @keyframes gDrift{from{transform:translate(0,0) scale(1)}to{transform:translate(40px,30px) scale(1.08)}}
  @keyframes gDrift2{from{transform:translate(-50%,-50%) scale(1)}to{transform:translate(-45%,-45%) scale(1.1)}}
  .gate-grid{position:absolute;inset:0;background-image:radial-gradient(rgba(255,255,255,.05) 1px,transparent 1px);background-size:32px 32px}
  .gate-card{position:relative;z-index:1;width:440px;background:rgba(35,31,32,.82);backdrop-filter:blur(28px);-webkit-backdrop-filter:blur(28px);border-radius:20px;overflow:hidden;box-shadow:0 0 0 1px rgba(255,255,255,.07),0 32px 64px rgba(0,0,0,.6);animation:gRise .75s cubic-bezier(.16,1,.3,1) both}
  @keyframes gRise{from{opacity:0;transform:translateY(30px) scale(.96)}to{opacity:1;transform:none}}
  .gate-topbar{height:5px;background:var(--ttl-grad)}
  .gate-body{padding:44px 44px 40px;display:flex;flex-direction:column;align-items:center}
  .gate-logo-wrap{margin-bottom:28px;display:flex;flex-direction:column;align-items:center;gap:12px}
  .gate-logo-ring{width:84px;height:84px;border-radius:50%;padding:3px;background:var(--ttl-grad);animation:gPulse 4s ease-in-out infinite}
  @keyframes gPulse{0%,100%{box-shadow:0 8px 32px rgba(130,74,248,.35)}50%{box-shadow:0 8px 52px rgba(130,74,248,.65)}}
  
  .gate-logo-ring img{width:100%;height:100%;border-radius:50%;object-fit:cover;display:block}
  .gate-logo-inner{width:100%;height:100%;border-radius:50%;background:var(--ttl-dark);display:flex;align-items:center;justify-content:center;font-size:32px;font-weight:900;color:#fff;letter-spacing:-2px;}
  
  .gate-heading{text-align:center;margin-bottom:28px}
  .gate-heading h1{font-size:26px;font-weight:700;color:#fff;line-height:1.2;margin-bottom:4px}
  .gate-heading h2{font-size:15px;font-weight:600;background:var(--ttl-grad);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;letter-spacing:.08em;text-transform:uppercase;margin-bottom:12px}
  .gate-heading p{font-size:13px;color:rgba(255,255,255,.35)}
  
  /* FORM STYLES */
  .gate-form{width:100%;display:flex;flex-direction:column;margin-bottom:24px;}
  .gate-input{width:100%;padding:12px 14px;background:rgba(0,0,0,0.25);border:1px solid rgba(255,255,255,0.1);border-radius:6px;color:#fff;font-family:'Poppins',sans-serif;font-size:13px;margin-bottom:12px;outline:none;transition:border-color 0.2s;}
  .gate-input:focus{border-color:var(--ttl-purple);}
  .gate-input::placeholder{color:rgba(255,255,255,0.3);}
  .gate-btn{width:100%;padding:12px;background:var(--ttl-grad);border:none;border-radius:6px;color:#fff;font-family:'Poppins',sans-serif;font-size:14px;font-weight:600;cursor:pointer;transition:opacity 0.2s;display:flex;justify-content:center;align-items:center;gap:8px;}
  .gate-btn:hover{opacity:0.9;}
  .gate-btn:disabled{opacity:0.5;cursor:not-allowed;}
  
  /* FEEDBACK MESSAGES */
  .gate-error{color:var(--ttl-coral);font-size:12px;margin-bottom:12px;text-align:center;background:rgba(243,118,100,0.1);padding:8px;border-radius:4px;border:1px solid rgba(243,118,100,0.2);}
  .gate-success{color:var(--accent-success);font-size:12px;margin-bottom:12px;text-align:center;background:rgba(16,185,129,0.1);padding:8px;border-radius:4px;border:1px solid rgba(16,185,129,0.2);}
  
  /* LINKS & DIVIDERS */
  .gate-link{color:var(--ttl-blue);font-size:12px;text-decoration:none;cursor:pointer;transition:opacity 0.2s;text-align:center;margin-top:14px;background:none;border:none;font-family:'Poppins',sans-serif;}
  .gate-link:hover{opacity:0.8;text-decoration:underline;}
  .gate-divider{width:100%;height:1px;background:rgba(255,255,255,.08);margin-bottom:24px;position:relative}
  .gate-divider::after{content:'OR';position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background:#2b2223;padding:0 12px;font-size:10px;font-weight:600;color:rgba(255,255,255,.3)}
  
  /* GLASSMORPHIC GOOGLE BUTTON */
  .gate-gbtn{width:100%;display:flex;align-items:center;justify-content:center;gap:10px;padding:12px;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:6px;cursor:pointer;transition:all 0.2s ease;margin-bottom:24px;}
  .gate-gbtn:hover{background:rgba(255,255,255,0.1);border-color:rgba(255,255,255,0.25);}
  .gate-gbtn:active{transform:scale(0.98);}
  .gate-gbtn:disabled{opacity:0.5;cursor:not-allowed;}
  .gate-gico{width:18px;height:18px;display:block;}
  .gate-gtxt{font-family:'Poppins',sans-serif;font-size:13px;font-weight:500;color:#fff;letter-spacing:0.02em;}
  
  .gate-footer p{font-size:11px;color:rgba(255,255,255,.2);line-height:1.7;text-align:center}
  .gate-footer a{color:var(--ttl-blue);text-decoration:none;font-weight:500}
  .gate-ver{position:fixed;bottom:18px;right:18px;font-size:10px;font-weight:500;color:rgba(255,255,255,.18);letter-spacing:.1em}
  @media(max-width:480px){.gate-card{width:92vw}.gate-body{padding:36px 28px 32px}}
`;

const TigerGate = ({ forceRecoveryMode, onAuthenticating }) => {
  const [view, setView] = useState(forceRecoveryMode ? 'UPDATE_PASSWORD' : 'LOGIN'); 
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(forceRecoveryMode ? "Link verified! Please establish your new credentials." : null);
  const [imgError, setImgError] = useState(false);

  // RMI-2026-478: Supabase redirects auth failures back here as an error
  // instead of a session -- neither this component nor AuthContext.jsx
  // parsed it before, so the user just saw a blank login form with no
  // explanation of what went wrong. Confirmed via live reports this can
  // arrive TWO ways depending on the flow: as a #error=... hash fragment
  // (email link / OTP verification) or as a ?error=... query string (the
  // Google OAuth redirect) -- must check both, not just one.
  useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const searchParams = new URLSearchParams(window.location.search);
    const errorCode = hashParams.get('error_code') || searchParams.get('error_code');
    if (!errorCode) return;
    const errorDescription = hashParams.get('error_description') || searchParams.get('error_description');

    setMessage(null);
    if (errorCode === 'otp_expired') {
      // Superseded/expired one-time link (password reset, invite) -- the
      // fix is on the user's end, send them straight to request a new one.
      setView('RECOVERY_REQUEST');
      setError("That link has expired or was already used — only the most recently requested link works. Enter your email below to request a new one.");
    } else if (errorCode === 'user_banned') {
      // Account-level block (set directly in Supabase, not via this app's
      // own admin tooling) -- no self-service fix, don't send them to the
      // password reset form since that won't help.
      setView('LOGIN');
      setError("Your account access has been suspended. Please contact an administrator.");
    } else {
      setView('LOGIN');
      setError(errorDescription || "Sign-in failed. Please try again or contact an administrator.");
    }
    // Strip the error out of the URL so refreshing or sharing this tab doesn't re-show it.
    window.history.replaceState(null, '', window.location.pathname);
  }, []);

  // RMI-2026-480: AuthContext.jsx flags a significantly-skewed client clock
  // via sessionStorage (a freshly issued session that already looks
  // expired, or absurdly long-lived, the moment it's set). Left
  // undiagnosed this looks like a random, unexplained repeating logout --
  // the session establishes, a refresh loop kicks off since it thinks the
  // token is already stale, Supabase rate-limits the refresh attempts, and
  // the resulting failure signs the user back out. Surface it plainly
  // instead of leaving the user to guess.
  useEffect(() => {
    let driftSec;
    try { driftSec = sessionStorage.getItem('tecc_clock_skew_drift_sec'); } catch (_) { driftSec = null; }
    if (!driftSec) return;
    try { sessionStorage.removeItem('tecc_clock_skew_drift_sec'); } catch (_) { /* ignore */ }
    const driftMin = Math.round(Math.abs(Number(driftSec)) / 60);
    setView('LOGIN');
    setMessage(null);
    setError(`Your computer's clock appears to be set incorrectly (off by roughly ${driftMin} minute${driftMin === 1 ? '' : 's'}), which can sign you out unexpectedly. Please correct your system date, time, and time zone, then try again.`);
  }, []);

  useEffect(() => {
    if (forceRecoveryMode) {
      setView('UPDATE_PASSWORD');
      setMessage("Link verified! Please establish your new credentials.");
      setError(null);
    }

    const { data: authListener } = supabase.auth.onAuthStateChange(async (event, _session) => {
      if (event === 'PASSWORD_RECOVERY') {
        setView('UPDATE_PASSWORD');
        setMessage("Link verified! Please establish your new credentials.");
        setError(null);
      }
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, [forceRecoveryMode]);

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) return setError("Please enter both email and password.");
    if (onAuthenticating) onAuthenticating();
    setLoading(true); setError(null); setMessage(null);
    try {
      const { error: authError } = await supabase.auth.signInWithPassword({ email, password });
      if (authError) throw authError;
    } catch (err) { setError(err.message || "Invalid login credentials."); } 
    finally { setLoading(false); }
  };

  const handleGoogleLogin = async () => {
    if (onAuthenticating) onAuthenticating();
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin,
        // Force Google's account chooser on every sign-in attempt instead of
        // silently reusing the browser's currently-active Google session.
        // Only fires on an active button click -> redirect; never on a page
        // refresh, so session auto-refresh while logged in is unaffected.
        queryParams: { prompt: 'select_account' },
      }
    });
  };

  const handleRequestReset = async (e) => {
    e.preventDefault();
    if (!email) return setError("Please enter your email address to reset your password.");
    
    setLoading(true); setError(null); setMessage(null);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin, 
      });
      if (error) throw error;
      setMessage("Check your email for the password reset link.");
    } catch (err) { setError(err.message); } 
    finally { setLoading(false); }
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    if (!password || password.length < 6) return setError("Password must be at least 6 characters.");
    
    setLoading(true); setError(null); setMessage(null);
    try {
      const { error } = await supabase.auth.updateUser({ password: password });
      if (error) throw error;
      
      setMessage("Password successfully updated! Redirecting to the portal...");
      
      setTimeout(() => {
         window.location.href = window.location.origin;
      }, 1500);
      
    } catch (err) { setError(err.message); } 
    finally { setLoading(false); }
  };

  return (
    <>
      <style>{styles}</style>
      <div className="gate-root">
        <div className="gate-bg">
          <div className="gate-blob gate-blob--1" />
          <div className="gate-blob gate-blob--2" />
          <div className="gate-blob gate-blob--3" />
          <div className="gate-grid" />
        </div>
        <div className="gate-card">
          <div className="gate-topbar" />
          <div className="gate-body">
            <div className="gate-logo-wrap">
              <div className="gate-logo-ring">
                {!imgError ? (
                  <img src={logo} alt="Tiger Technology & Logistics" onError={() => setImgError(true)} />
                ) : (
                  <div className="gate-logo-inner">TE</div>
                )}
              </div>
            </div>
            
            <div className="gate-heading">
              <h1>Tiger Eye</h1>
              <h2>Enterprise Portal</h2>
              <p>
                {view === 'LOGIN' && 'Sign in to access your secure portal'}
                {view === 'RECOVERY_REQUEST' && 'Reset your password'}
                {view === 'UPDATE_PASSWORD' && 'Establish your new credentials'}
              </p>
            </div>
            
            {view === 'LOGIN' && (
              <>
                <form className="gate-form" onSubmit={handleEmailLogin}>
                  {error && <div className="gate-error">{error}</div>}
                  {message && <div className="gate-success">{message}</div>}
                  
                  <input type="email" className="gate-input" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} disabled={loading} autoComplete="email" />
                  <input type="password" className="gate-input" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} disabled={loading} autoComplete="current-password" />
                  
                  <button type="submit" className="gate-btn" disabled={loading}>
                    {loading ? 'Authenticating...' : 'Sign In'}
                  </button>
                  <button type="button" className="gate-link" onClick={() => { setView('RECOVERY_REQUEST'); setError(null); setMessage(null); }}>
                    Forgot Password?
                  </button>
                </form>

                <div className="gate-divider" />
                
                <button type="button" className="gate-gbtn" onClick={handleGoogleLogin} disabled={loading}>
                  <img className="gate-gico" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" />
                  <span className="gate-gtxt">Sign in with Google</span>
                </button>
              </>
            )}

            {view === 'RECOVERY_REQUEST' && (
              <form className="gate-form" onSubmit={handleRequestReset}>
                {error && <div className="gate-error">{error}</div>}
                {message && <div className="gate-success">{message}</div>}
                
                <input type="email" className="gate-input" placeholder="Enter your email address" value={email} onChange={(e) => setEmail(e.target.value)} disabled={loading} autoComplete="email" />
                
                <button type="submit" className="gate-btn" disabled={loading}>
                  {loading ? 'Sending Link...' : 'Send Reset Link'}
                </button>
                <button type="button" className="gate-link" onClick={() => { setView('LOGIN'); setError(null); setMessage(null); }}>
                  Back to Login
                </button>
              </form>
            )}

            {view === 'UPDATE_PASSWORD' && (
              <form className="gate-form" onSubmit={handleUpdatePassword}>
                {error && <div className="gate-error">{error}</div>}
                {message && <div className="gate-success">{message}</div>}
                
                <input type="password" className="gate-input" placeholder="Enter new password" value={password} onChange={(e) => setPassword(e.target.value)} disabled={loading} autoComplete="new-password" />
                
                <button type="submit" className="gate-btn" disabled={loading}>
                  {loading ? 'Updating...' : 'Set New Password'}
                </button>
              </form>
            )}

            <div className="gate-footer">
              <p>Access restricted to authorized Tiger T&amp;L personnel.<br/>
              Questions? <a href="mailto:info@tigertechlogis.com">info@tigertechlogis.com</a></p>
            </div>
          </div>
        </div>
        <div className="gate-ver">TECC v0.6.6</div>
      </div>
    </>
  );
};

export default TigerGate;

/*
================================================================================
CHANGE MANIFEST
================================================================================
VER 0.6.11 - 2026-08-17 - RMI-2026-480: surface client clock-skew logouts
- The actual root cause behind the whole RMI-2026-478/479 saga, confirmed
  via a console screenshot: a user's system clock running ~2 hours fast,
  which made every freshly issued session look already expired, triggering
  a refresh loop, a Supabase 429 rate-limit, and a SIGNED_OUT-driven bounce
  back here with zero explanation.
- New effect reads the sessionStorage flag AuthContext.jsx's new
  checkClockSkew() sets (VER 2.7), shows a clear message naming the
  drift in minutes and telling the user to fix their system clock/time
  zone, then clears the flag so it doesn't repeat on the next visit.
=========================================
VER 0.6.10 - 2026-08-17 - RMI-2026-478 follow-up: distinguish ban vs expired link
- Follow-up to VER 0.6.9. User clarified she'd clicked "Sign in with Google"
  (no email link involved), then a fresh repro screenshot showed a DIFFERENT
  error: ?error=access_denied&error_code=user_banned&error_description=User
  +is+banned -- as a QUERY STRING, not the #hash the first error arrived as.
  The VER 0.6.9 effect only checked window.location.hash, so it would have
  missed this case entirely.
- Confirmed via the DB this was a genuine Supabase Auth-level ban
  (auth.users.banned_until), set and later cleared directly against the
  Supabase project -- NOT through this app's own admin deactivate-account
  tooling (api/account-active.js always writes a system_activity_logs
  entry; there were zero for this user). Not an app bug -- the account is
  usable again now that the ban is cleared.
- Effect now checks both window.location.hash AND window.location.search
  for error_code, and branches the message/view by code: `otp_expired`
  still routes to RECOVERY_REQUEST (self-service fix, request a new link);
  `user_banned` now shows "contact an administrator" and stays on LOGIN
  instead of misleadingly suggesting a password reset would help.
================================================================================
VER 0.6.9 - 2026-08-17 - RMI-2026-478: surface expired/invalid auth-link errors
- User report: bizdev@tigertechlogis.com logs on, dashboard doesn't stay,
  returned to login screen. Root cause: Supabase redirects an expired or
  already-used password-reset/invite link back here as
  #error=access_denied&error_code=otp_expired&error_description=... instead
  of a session -- neither this file nor AuthContext.jsx parsed that hash, so
  the user just saw a blank login form with zero explanation. Most commonly
  caused by clicking a superseded link after requesting a newer one, waiting
  too long, or a corporate email security scanner pre-visiting the single-use
  link before the person actually clicks it.
- New mount effect detects `error=` in the hash, shows a clear message,
  routes straight to the RECOVERY_REQUEST view (just re-enter email and
  submit), and strips the error out of the URL via history.replaceState so
  refreshing doesn't re-show it.
================================================================================
VER 0.6.8 - June 4, 2026 - BUILD-2026.356
- Google OAuth account chooser: handleGoogleLogin now passes
  queryParams: { prompt: 'select_account' } to supabase.auth.signInWithOAuth.
  Forces Google to show the account picker on every sign-in click instead of
  silently auto-selecting the browser's active Google session, allowing a
  different Google identity to be chosen at login.
- No impact on logged-in refresh (the prompt fires only on the click->redirect
  path, never on page reload) or on logout token revocation (handled in
  AuthContext signOut). No other files changed for this behavior.
================================================================================
VER 0.6.7 - May 13, 2026
- Accepts onAuthenticating() prop from AppRouter. Called on Google click and
  email submit so AppRouter can swap to AppLoader immediately, preventing
  TigerGate from re-rendering during the auth resolution window.
================================================================================
VER 0.6.6 - 2026-05-03
- COPY UPDATE: Replaced "Command Center" with "Enterprise Portal" in the `h2`
  heading to provide unified terminology suitable for both clients and
  internal staff.
- UX TEXT: Updated the login subtitle to read "Sign in to access your secure
  portal".
- UX TEXT: Updated the password reset success redirect message to match the
  new portal nomenclature.
================================================================================
*/
/* [ END OF MODULE - VER 0.6.11 (src/TigerGate.jsx) ] */